<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      class="mb-4"
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '조사일'},
        { type: 'text', label: '공정내용'},
        { type: 'disaster', label: '재해형태'}
      ]"
    />

    <!-- 근골격계부담작업 -->
    <MusculoskeletalTensionExercisesTable
      v-model="form.table"
      :readonly="board.readonly"
      :is-print="isPrint"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import MusculoskeletalTensionExercisesTable from '@/views/boards/single-page/293/MusculoskeletalTensionExercisesTable'

export default {
  components: {
    MusculoskeletalTensionExercisesTable,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object | undefined,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        table: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
